import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { formatDateIST, formatDateTimeIST } from "./datetime-ist";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Display date in IST (Asia/Kolkata). */
export function formatDate(date) {
  return formatDateIST(date);
}

/** Display date+time in IST (Asia/Kolkata). */
export function formatDateTime(date) {
  return formatDateTimeIST(date);
}

export function truncate(str, length = 50) {
  if (!str) return "";
  if (str.length <= length) return str;
  return str.substring(0, length) + "...";
}

export function getInitials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .substring(0, 2);
}
